import { message, Select } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Form,
    ModalItem,
    FormItem,
    SelectItem,
    InputItem,
    ButtonItem,
} from "../../../../Components/Items";

const { Option } = Select;

// El SAT pide la placa sin espacios ni guiones, de 5 a 7 caracteres
export const normalizarPlaca = (value) => (value ? String(value).toUpperCase().replace(/[\s-]/g, "") : value);
export const reglasPlaca = [
    { pattern: /^[A-Z0-9]{5,7}$/, message: "La placa debe tener de 5 a 7 letras o números" },
];

class AgregarRemolque extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        todasSubtiposRemolques: null,
        objetoSubtiposRemolques: null,
    };
    componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible && this.props.visible)
            this.consultarTodo();
    }
    async consultarTodo() {
        this.setState({ loading: true });
        await axios
            .post("remolques/selectDatosParaRemolque", null, {
                headers: this.props.headersToken,
            })
            .then((res) => {
                if (res.data.success === 2) {
                    this.setState({
                        todasSubtiposRemolques: res.data.subtiposRemolques,
                        objetoSubtiposRemolques: res.data.subtiposRemolques.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.Clave + ' - ' + value.Descripcion}
                                </Option>
                            );
                        }),
                    });
                }
            });
        this.setState({ loading: false });
    }
    cerrarAgregarRemolque(codigo) {
        this.props.cerrarAgregarRemolque(codigo);
    }
    onFinishFailed(e) {
        message.error("Revisa que los datos sean correctos");
    }
    onFinish(values) {
        this.setState({ loading: true });
        axios
            .post(
                "remolques/agregarRemolque",
                { ...values, empresaId: this.props.empresaId },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    if (res.data.existente) {
                        message.info("Ya existía un remolque con esa placa, se usará ese");
                    } else {
                        message.success("Se agrego un remolque");
                    }
                    this.formRef.current.resetFields();
                    this.cerrarAgregarRemolque(res.data.remolqueId);
                } else {
                    message.error("Sucedio un error y no se guardo");
                }
            });
    }
    render() {
        return (
            <ModalItem
                title="Agregar Remolque"
                visible={this.props.visible}
                spinning={this.state.loading}
                onCancel={this.cerrarAgregarRemolque.bind(this)}
                paddingTop
            >
                <Form
                    ref={this.formRef}
                    name="agregarRemolque"
                    layout
                    bottom={
                        <ButtonItem
                            type="primary"
                            htmlType="submit"
                            style={{ display: "block", margin: "0 0 0 auto" }}
                        >
                            Agregar
                        </ButtonItem>
                    }
                    onFinish={this.onFinish.bind(this)}
                    onFinishFailed={this.onFinishFailed}
                >
                    <FormItem
                        label='Placa'
                        name='placa'
                        margin
                        required
                        normalize={normalizarPlaca}
                        rules={reglasPlaca}
                    >
                        <InputItem placeholder='Placa' />
                    </FormItem>
                    <FormItem required label="Subtipo R." name="subtipoRemolqueSatId" margin>
                        <SelectItem placeholder="Subtipo R.">
                            {this.state.objetoSubtiposRemolques}
                        </SelectItem>
                    </FormItem>
                    <FormItem
                        label='Descripcion'
                        name='descripcion'
                        pattern
                        margin
                    >
                        <InputItem placeholder='Si se deja vacía se usa la del subtipo' />
                    </FormItem>
                </Form>
            </ModalItem>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
    };
};

export default connect(mapStateToProps)(AgregarRemolque);
